export default {
  mounted() {
    this._trackMouseDown = (e) => { this._lastMouseDownTarget = e.target }
    document.addEventListener('mousedown', this._trackMouseDown, true)
  },
  beforeDestroy() {
    clearTimeout(this._blurCheckTimeout)
    document.removeEventListener('mousedown', this._trackMouseDown, true)
    if (this._focusLeaveHandler) document.removeEventListener('focusin', this._focusLeaveHandler)
    if (this._mouseDownOutsideHandler) document.removeEventListener('mousedown', this._mouseDownOutsideHandler)
  },
  methods: {
    _watchForFocusLeave() {
      if (this._focusLeaveHandler) document.removeEventListener('focusin', this._focusLeaveHandler)
      if (this._mouseDownOutsideHandler) document.removeEventListener('mousedown', this._mouseDownOutsideHandler)

      const cleanup = () => {
        document.removeEventListener('focusin', this._focusLeaveHandler)
        document.removeEventListener('mousedown', this._mouseDownOutsideHandler)
        this._focusLeaveHandler = null
        this._mouseDownOutsideHandler = null
      }

      this._focusLeaveHandler = (e) => {
        if (!this.$el) { cleanup(); return }
        if (this.$el.contains(e.target)) { cleanup(); return }
        cleanup()
        this.$emit('component-blur')
      }

      this._mouseDownOutsideHandler = (e) => {
        if (!this.$el) { cleanup(); return }
        if (this.$el.contains(e.target)) return
        cleanup()
        this.$emit('component-blur')
      }

      document.addEventListener('focusin', this._focusLeaveHandler)
      document.addEventListener('mousedown', this._mouseDownOutsideHandler)
    },
    onComponentFocusOut() {
      clearTimeout(this._blurCheckTimeout)
      this._blurCheckTimeout = setTimeout(() => {
        const active = document.activeElement
        if (!active || active === document.body) {
          // Last mousedown was on a live element outside this panel — genuine click away.
          // Skip if element was removed from DOM (e.g. datepicker popup close).
          if (
            this._lastMouseDownTarget &&
            document.documentElement.contains(this._lastMouseDownTarget) &&
            !this.$el.contains(this._lastMouseDownTarget)
          ) {
            this.$emit('component-blur')
            return
          }
          // Focus settling after datepicker/popup interaction — wait for next deliberate action.
          this._watchForFocusLeave()
          return
        }
        if (this.$el && !this.$el.contains(active)) {
          this.$emit('component-blur')
        }
      }, 0)
    }
  }
}
